
import {css} from "lit"
export default css`

.accounting {
	display: flex;
	align-items: stretch;
	flex-wrap: wrap;
	gap: 0.5em;
}

`

